import { Lote } from "./Lote";
import { Ticket } from "./Ticket";
import { Venda } from "./Venda";

export class ItemVenda {
    public id: number;
    public venda: Venda;
    public lote: Lote;
    public ticket: Ticket;
}